
export default {
  name: 'icon-filter',
};
